module.exports = __webpack_public_path__ + "static/media/aepe.4299e144.jpg";